import citizenship from "./checkout/services/citizenship";

$(document).ready(function () {
    for (const [key, value] of Object.entries(citizenship.data.countries)) {
        $('#citizenship').append('<option value="'+ value.code +'">'+ value.name +'</option>')
    }

    $('#citizenship').change(function (e) {
        e.preventDefault()
        $('#documents option').not(':disabled').remove()

        for (const [key, value] of Object.entries(citizenship.getIdentifiedByKeys($(this).val(), false))) {
            $('#documents').append('<option value="'+ value.value +'">'+ value.key +'</option>')
        }

    })

    setTimeout(function () {
        if ($('#citizenship').data('old') !== '') {
            $('#citizenship option[value="'+ $('#citizenship').data('old') +'"]').attr('selected', true)
        }
        if ($('#documents').data('old') !== '') {
            $('#citizenship').change()
            $('#documents option[value="'+ $('#documents').data('old') +'"]').attr('selected', true)
        }
    }, 500)

    var initSelect2 = function () {
        // function that will initialize the select2 plugin, to be triggered later
        var renderSelect = function () {
            let query = {
                city: "",
                street: "",
                zipcode: "",
                house_number: "",
            };

            if ($(".ajax-old-postal_code").length) {
                var $postalCodeOption = $("<option selected>")
                    .val($(".ajax-old-postal_code").text())
                    .text($(".ajax-old-postal_code").text());
                $('.ajax select[name="postal_code"]')
                    .append($postalCodeOption)
                    .trigger("change");
                query["zipcode"] = $(".ajax-old-postal_code").text();
            }

            if ($(".ajax-old-city").length) {
                var $oldCityOption = $("<option selected>")
                    .val($(".ajax-old-city").text())
                    .text($(".ajax-old-city").text());
                $('.ajax select[name="city"]')
                    .append($oldCityOption)
                    .trigger("change");
                query["city"] = $(".ajax-old-city").text();
            }

            if ($(".ajax-old-address").length) {
                var $oldAddressOption = $("<option selected>")
                    .val($(".ajax-old-address").text())
                    .text($(".ajax-old-address").text());
                $('.ajax select[name="address"]')
                    .append($oldAddressOption)
                    .trigger("change");
                query["street"] = $(".ajax-old-address").text();
            }

            if ($(".ajax-old-number").length) {
                var $oldNumberOption = $("<option selected>")
                    .val($(".ajax-old-number").text())
                    .text($(".ajax-old-number").text());
                $('.ajax select[name="number"]')
                    .append($oldNumberOption)
                    .trigger("change");
                query["house_number"] = $(".ajax-old-number").text();
            }

            $('.ajax select[name="address"]').select2({
                language: "de",
                dropdownParent: $("#sim_registration_container"),
                placeholder: $(".ajax-old-address").length
                    ? $(".ajax-old-address").text()
                    : "",
                minimumInputLength: 3,
                templateSelection: function (data) {
                    query["street"] = data.text;
                    return data.text;
                },
                ajax: {
                    url: "/public-api/address-population",
                    type: "POST",
                    delay: 750,
                    dataType: "json",
                    data: function (params) {
                        query["street"] = params.term;
                        query["street_like"] = true;

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    },
                    processResults: function (data) {
                        // Transforms the top-level key of the response object from 'items' to 'results'
                        query["street_like"] = null;
                        countResults(data);
                        $(".internet-error-message").addClass("d-none");
                        return {
                            results: $.map(data.street, function (obj) {
                                return { id: obj, text: obj };
                            }),
                        };
                    },
                    error: function (jqXHR, status, error) {
                        $(".internet-error-message").removeClass("d-none");
                        query["street"] = "";
                        return { results: [] }; // Return dataset to load after error
                    },
                },
            });

            $('.ajax select[name="number"]').select2({
                language: "de",
                dropdownParent: $("#sim_registration_container"),
                placeholder: $(".ajax-old-number").length
                    ? $(".ajax-old-number").text()
                    : "",
                minimumInputLength: 1,
                templateSelection: function (data) {
                    query["house_number"] = data.text;
                    return data.text;
                },
                ajax: {
                    url: "/public-api/address-population",
                    type: "POST",
                    delay: 750,
                    dataType: "json",
                    data: function (params) {
                        query["house_number"] = params.term;
                        query["house_number_like"] = true;

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    },
                    processResults: function (data) {
                        query["house_number_like"] = null;
                        // Transforms the top-level key of the response object from 'items' to 'results'
                        countResults(data);
                        $(".internet-error-message").addClass("d-none");
                        return {
                            results: $.map(data.house_number, function (obj) {
                                return { id: obj, text: obj };
                            }),
                        };
                    },
                    error: function (jqXHR, status, error) {
                        $(".internet-error-message").removeClass("d-none");
                        query["house_number"] = "";
                        return { results: [] }; // Return dataset to load after error
                    },
                },
            });

            $('.ajax select[name="postal_code"]').select2({
                language: "de",
                dropdownParent: $("#sim_registration_container"),
                placeholder: $(".ajax-old-postal_code").length
                    ? $(".ajax-old-postal_code").text()
                    : "",
                minimumInputLength: 2,
                templateSelection: function (data) {
                    query["zipcode"] = data.text;
                    return data.text;
                },
                ajax: {
                    url: "/public-api/address-population",
                    type: "POST",
                    delay: 750,
                    dataType: "json",
                    data: function (params) {
                        query["zipcode"] = params.term;
                        query["zipcode_like"] = true;

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    },
                    processResults: function (data) {
                        query["zipcode_like"] = null;
                        // Transforms the top-level key of the response object from 'items' to 'results'
                        countResults(data);
                        $(".internet-error-message").addClass("d-none");
                        return {
                            results: $.map(data.zipcode, function (obj) {
                                return { id: obj, text: obj };
                            }),
                        };
                    },
                    error: function (jqXHR, status, error) {
                        $(".internet-error-message").removeClass("d-none");
                        query["zipcode"] = "";
                        return { results: [] }; // Return dataset to load after error
                    },
                },
            });

            $('.ajax select[name="city"]').select2({
                language: "de",
                dropdownParent: $("#sim_registration_container"),
                placeholder: $(".ajax-old-city").length
                    ? $(".ajax-old-city").text()
                    : "",
                minimumInputLength: 2,
                templateSelection: function (data) {
                    query["city"] = data.text;
                    return data.text;
                },
                ajax: {
                    url: "/public-api/address-population",
                    type: "POST",
                    delay: 750,
                    dataType: "json",
                    data: function (params) {
                        query["city"] = params.term;
                        query["city_like"] = true;

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    },
                    processResults: function (data) {
                        query["city_like"] = null;
                        // Transforms the top-level key of the response object from 'items' to 'results'
                        countResults(data);
                        $(".internet-error-message").addClass("d-none");
                        return {
                            results: $.map(data.city, function (obj) {
                                return { id: obj, text: obj };
                            }),
                        };
                    },
                    error: function (jqXHR, status, error) {
                        $(".internet-error-message").removeClass("d-none");
                        query["city"] = "";
                        return { results: [] }; // Return dataset to load after error
                    },
                },
            });
            const countResults = function (data) {
                if (
                    data.city.length < 5 &&
                    data.house_number.length < 5 &&
                    data.street.length < 5 &&
                    data.zipcode.length < 5
                ) {
                    $(".ajax .dalje-button").addClass("green-button");
                } else {
                    $(".ajax .dalje-button").removeClass("green-button");
                }
            };
        };

        // create select2 HTML elements
        var style = document.createElement("link");
        var script = document.createElement("script");
        var scriptLang = document.createElement("script");
        style.rel = "stylesheet";
        style.href =
            "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css";
        script.type = "text/javascript";
        script.src =
            "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js";
        scriptLang.type = "text/javascript";
        scriptLang.src = `https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/i18n/${document.documentElement.lang}.js`;
        
        // trigger the select2 initialization once the script tag has finished loading
        script.onload = function(){
            document.getElementsByTagName("head")[0].appendChild(scriptLang);
        }
        scriptLang.onload = renderSelect;

        // render the style and script tags into the DOM
        document.getElementsByTagName("head")[0].appendChild(style);
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    initSelect2();
})
